import { t } from 'ttag'
import { FlightIssue } from '../ClaimForm/FlightDetailsForm'
import { ClaimFormState } from '../ClaimForm/state'

const EMAIL_REGEX = /[^@\s]+@[^@\s]+(?:\.[^@\s]+)+/
const PHONE_NUMBER_REGEX = /^[0-9 +\-()]+$/
const TIME_REGEX = /(\d\d?):(\d\d)/


export function required(errorMessage = null) {
    return function (value) {
        if (!errorMessage) {
            errorMessage = t`This field is required`
        }

        if (value === null || String(value).trim() === '') {
            return errorMessage
        }
        return null
    }
}


export function validateFullName (value) {
    if (value.split(' ').length < 2) {
        return t`Please enter the full passenger name (including family name)`
    }
    return null
}


export function validateEmail (value) {
    if (!value) return null

    value = value.trim()

    if (value.length > 0 && !EMAIL_REGEX.test(value)) {
        return t`Please enter a valid email address`
    }

    return null
}


export function validatePhoneNumber (value) {
    if (!value) return null

    value = value.trim()

    if (value.length > 0 && !PHONE_NUMBER_REGEX.test(value)) {
        return t`Please enter a valid phone number`
    }

    return null
}


export function validateFlightNumber (value) {
    value = value.replace(/[^0-9a-z]/gi, '')

    let prefix = ''
    let flightNumber = value

    let genericErrorMsg = t`Please enter a valid flight number`
    let tooLongErrorMsg = t`Flight number should be shorter`

    // Don't allow empty input
    if (flightNumber.length == 0) {
        return genericErrorMsg
    }

    // Unprefixed flight number, digits only
    if (/^\d+$/.test(flightNumber)) {
        // Accept 4 digits max
        if (flightNumber.length > 4) {
            return tooLongErrorMsg
        }

        return null
    }

    // Prefixed flight number
    // To determine if an IATA or ICAO prefix is present, we rely on the (currently
    // correct) assumption that ICAO codes end on a letter

    let prefixLen = 2  // Expect the more common 2 char IATA prefix
    if (/[a-z]/i.test(flightNumber[2])) {
        // Appears to be a 3 character ICAO prefix
        prefixLen = 3
    }

    prefix = flightNumber.slice(0, prefixLen)
    flightNumber = flightNumber.slice(prefixLen)

    if (flightNumber.length == 0 || !/\d+$/.test(flightNumber)) {
        return t`Flight number must end with at least one digit`
    }

    if (flightNumber.replace(/^0*/, '').length == 0) {
        // All zeroes, not a valid flight number
        return genericErrorMsg
    }

    if (flightNumber.length > 4) {
        return tooLongErrorMsg
    }

    if (!/^\d+$/.test(flightNumber)) {
        return genericErrorMsg
    }

    return null
}


export function validateOnlyTrueCheckbox (value) {
    if (!value) {
        return t`Please check the box`
    }
    return null
}

export const validateCancellationNotification = (form: ClaimFormState) => () => {
    const flightForm = form.formState.flights.$
    if (!flightForm.flight_cancellation_notification.value) {
        if (flightForm.flight_issue.value === FlightIssue.CANCELLED) {
            return t`Please select the flight cancellation notification time`
        }
    }
    return null
}

export const validateArrivalDelay = (form: ClaimFormState) => () => {
    const flightForm = form.formState.flights.$
    if (!flightForm.arrival_delay.value) {
        if (flightForm.flight_issue.value === FlightIssue.LATE_ARRIVAL) {
            return t`Please select the flight delay time`
        }
    } else if (flightForm.arrival_delay.value <= 3) {
        return t`The flight delay time must be more than 3 hours`
    }
    return null
}
